import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-acb690d6")

_pushScopeId("data-v-acb690d6")
const _hoisted_1 = { class: "mx-2 relative" }
const _hoisted_2 = { class: "bg-white shadow-lg rounded w-60 overflow-y-scroll py-2 max-h-120" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex items-center px-2 py-1 rounded cursor-pointer transition-colors duration-300 hover:bg-white hover:text-primary-500", {
        'text-gray-600': !_ctx.active,
        'text-primary-500': _ctx.active
      }],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleShowModal && _ctx.handleShowModal(...args)))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createVNode("div", {
      class: ["absolute left-0 pt-2 z-10", { hidden: !_ctx.showModal }]
    }, [
      _createVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "body")
      ])
    ], 2)
  ]))
})